// React
import { injectIntl } from 'react-intl'
import { connect } from 'react-redux'
// External libs
import { get } from 'lodash'
// Components
import StoresSchedulesPage from './StoresSchedulesPage'

const mapStateToProps = (
  { ordersReducer, partnerReducer: { profile } },
  { intl: { formatMessage } },
) => {
  const title = formatMessage({
    id: 'storesSchedulePage.title',
  })
  const regularScheduleTitle = formatMessage({
    id: 'storesSchedulePage.regularSchedule',
  })
  const holidaysScheduleTitle = formatMessage({
    id: 'storesSchedulePage.holidays',
  })
  const specialDayScheduleTitle = formatMessage({
    id: 'storesSchedulePage.specialDay',
  })
  const regularScheduleDescription = formatMessage({
    id: 'storesSchedulePage.regularScheduleDescription',
  })
  const specialDayScheduleDescription = formatMessage({
    id: 'storesSchedulePage.specialDayScheduleDescription',
  })
  const holidaysScheduleDescription = formatMessage({
    id: 'storesSchedulePage.holidaysScheduleDescription',
  })
  const regularScheduleAlert = formatMessage(
    {
      id: 'storesSchedulePage.regularScheduleAlert',
    },
    { phone: get(profile, 'support_phone', '') },
  )
  const holidayScheduleAlert = formatMessage({
    id: 'storesSchedulePage.holidayScheduleAlert',
  })
  const specialDayScheduleAlert = formatMessage({
    id: 'storesSchedulePage.specialDayScheduleAlert',
  })
  return {
    title,
    regularScheduleTitle,
    specialDayScheduleTitle,
    holidaysScheduleTitle,
    regularScheduleDescription,
    specialDayScheduleDescription,
    holidaysScheduleDescription,
    holidayScheduleAlert,
    regularScheduleAlert,
    specialDayScheduleAlert,
  }
}

const mapDispatchToProps = {}

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(StoresSchedulesPage),
)
